import WhatsApp from '@mui/icons-material/WhatsApp'
import React from 'react'
import { useNavigate } from 'react-router-dom-v5-compat'

import Navigator, { TNavigatorItem } from '@/app/component/atom/navigator'
import SidebarLayout from '@/app/component/layout/sidebar-layout'
import { LogProps, TabMap } from '@/app/module/logs/helpers'

import MessageList from './list'

const Log: React.FC<LogProps> = (props) => {
  const {
    downloadMessages,
    downloadCalls,
    downloadWhatsapp,
    downloadTopups,
    getMessages,
    getCalls,
    getWhatsapp,
    getTopups,
    reloadMessages,
    reloadCalls,
    reloadWhatsapp,
    reloadTopups,
    messages,
    calls,
    whatsapp,
    topups,
    tab = 'messages',
    clearFilters,
    orgId,
  } = props
  const navigate = useNavigate()

  const prevOrgRef = React.useRef<number | null>(null)

  React.useEffect(() => {
    if (prevOrgRef.current && prevOrgRef.current !== orgId) {
      navigate('/logs')
    }
    prevOrgRef.current = orgId
  }, [orgId, navigate])

  const tabProps: TabMap = {
    messages: {
      downloadData: downloadMessages,
      getData: getMessages,
      reloadData: reloadMessages,
      data: messages,
    },
    calls: {
      downloadData: downloadCalls,
      getData: getCalls,
      reloadData: reloadCalls,
      data: calls,
    },
    whatsapp: {
      downloadData: downloadWhatsapp,
      getData: getWhatsapp,
      reloadData: reloadWhatsapp,
      data: whatsapp,
    },
    topups: {
      downloadData: downloadTopups,
      getData: getTopups,
      reloadData: reloadTopups,
      data: topups,
    },
  }

  const unknownTab = !tab || (tab !== 'messages' && tab !== 'calls' && tab !== 'whatsapp' && tab !== 'topups')

  React.useEffect(() => {
    if (unknownTab) {
      navigate('/logs?tab=messages')
    }
  }, [unknownTab, navigate])

  const activeTab = unknownTab ? 'messages' : tab

  const handleItemClick = React.useCallback(
    (nextTab: LogTab) => {
      if (nextTab === tab) {
        return
      }

      clearFilters()
      navigate(`/logs?tab=${nextTab}`)
    },
    [clearFilters, tab, navigate],
  )

  const sidebar = (
    <Navigator activePath={activeTab} id="logs" items={navigatorItems} title="Logs" onItemClick={handleItemClick} />
  )

  const content = unknownTab ? null : <MessageList {...props} {...tabProps[tab]} tab={tab} />

  return <SidebarLayout sidebar={sidebar} content={content} />
}

type LogTab = LogProps['tab']

const navigatorItems: TNavigatorItem<LogTab>[] = [
  {
    icon: 'sms',
    label: 'SMS',
    path: 'messages',
  },
  {
    icon: 'call',
    label: 'Calls',
    path: 'calls',
  },
  {
    icon: (color) => <WhatsApp color={color} />,
    label: 'WhatsApp',
    path: 'whatsapp',
  },
  {
    icon: 'account_balance_wallet',
    label: 'Top-ups',
    path: 'topups',
  },
]

export default Log
